module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "auditForm",
    staticClass: "small-space",
    attrs: {
      "model": _vm.auditForm,
      "label-position": "left",
      "label-width": "100px",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核意见",
      "prop": "jcCzxmc"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请填写审核意见",
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.auditForm.opinion),
      callback: function($$v) {
        _vm.$set(_vm.auditForm, "opinion", $$v)
      },
      expression: "auditForm.opinion"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin": "10px 0 10px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": function($event) {
        return _vm.audit('1')
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-check"
  }), _vm._v(" 通 过\n        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": function($event) {
        return _vm.audit('2')
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-close"
  }), _vm._v(" 驳 回\n        ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a46394f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/audit/audit.vue
// module id = 1852
// module chunks = 502